import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Home from "../Home/Home";
import About from "../About/About";
import "./Main.scss";
import Skill from "../Skill/Skill";
import Experience from "../Experience/Experience";
import Project from "../Project/Project";
import Contact from "../Contact/Contact";
import Achievements from "../Achievements/Achievements";

function Main() {
  const [showIndicator, setShowIndicator] = useState(true);
  const containerRef = useRef(null);
  const location = useLocation();

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    const isBottom = scrollHeight - scrollTop <= clientHeight + 50;

    setShowIndicator(!isBottom);
  };

  useEffect(() => {
    const map = {
      "/": ".home-page",
      "/about": ".about-page",
      "/skill": ".skill-page",
      "/experience": ".experience-page",
      "/project": ".project-page",
      "/achievements": ".achievements-page",
      "/contact": ".contact-page",
    };

    const selector = map[location.pathname] || ".home-page";
    const container = containerRef.current;

    if (!container) return;

    // wait for render to settle, then smooth-scroll the container to the target
    const t = setTimeout(() => {
      const target = container.querySelector(selector);
      if (target) {
        // getBoundingClientRect gives position relative to the viewport, so we
        // compute the true scroll offset regardless of how deep the target is nested.
        const containerTop = container.getBoundingClientRect().top;
        const targetTop = target.getBoundingClientRect().top;
        const scrollTo = container.scrollTop + (targetTop - containerTop);
        container.scrollTo({ top: scrollTo, behavior: "smooth" });
      } else {
        container.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 100);

    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <>
      <div className={`scroll-indicator ${showIndicator ? "show" : "hide"}`}>
        <span className="scroll-text">Scroll Down</span>
        <svg
          className="scroll-arrow"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <polyline points="19 12 12 19 5 12"></polyline>
        </svg>
      </div>

      <div ref={containerRef} className="main-scroll-container" onScroll={handleScroll}>
        <Home />
        <About />
        <Skill />
        <Experience />
        <Project />
        <Achievements />
        <Contact />
      </div>
    </>
  );
}

export default Main;
